module.exports = __webpack_public_path__ + "static/media/product-service.194b96ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/image/product-service.svg
// module id = 160
// module chunks = 6